<script setup lang="ts">
const route = useRoute()
const slug = route.params.slug as string
const { imageUrl } = useDirectusImage()

const { data: entry } = await useFetch(`/api/lab/${slug}`)

if (!entry.value) {
  throw createError({ statusCode: 404, statusMessage: 'Lab entry not found' })
}

useSeoMeta({
  title: `${(entry.value as any).title} — Lab — Shakir Abdulrahim`,
  ogTitle: `${(entry.value as any).title} — Lab — Shakir Abdulrahim`,
  description: (entry.value as any).description,
})
</script>

<template>
  <div class="py-24">
    <div class="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <NuxtLink to="/lab" class="mb-8 inline-flex items-center gap-1 text-sm text-[var(--color-text-muted)] transition-colors hover:text-[var(--color-amber)]">
        <UIcon name="i-lucide-arrow-left" class="size-4" />
        Back to lab
      </NuxtLink>

      <h1 class="mb-4 text-4xl font-bold text-[var(--color-text)] sm:text-5xl">
        {{ (entry as any).title }}
      </h1>
      <p class="mb-6 text-lg text-[var(--color-text-muted)]">
        {{ (entry as any).description }}
      </p>

      <div v-if="(entry as any).tags" class="mb-8 flex flex-wrap gap-2">
        <span
          v-for="tag in (entry as any).tags"
          :key="tag"
          class="rounded-md border border-[var(--color-card-border)] bg-[var(--color-surface-hover)] px-3 py-1 text-sm text-[var(--color-text-muted)]"
        >
          {{ tag }}
        </span>
      </div>

      <img
        v-if="(entry as any).image"
        :src="imageUrl((entry as any).image, { width: 960, quality: 85 })!"
        :alt="(entry as any).title"
        class="mb-10 w-full rounded-xl"
      >

      <div
        v-if="(entry as any).content"
        class="prose dark:prose-invert max-w-none text-(--color-text-muted) prose-headings:text-(--color-text) prose-a:text-amber prose-strong:text-(--color-text) prose-code:text-amber"
        v-html="(entry as any).content"
      />
    </div>
  </div>
</template>
